import React from "react";
const ToggleSwitch = (props) => {
    function handleKeyPress(e) {
        if (e.keyCode !== 32)
            return;
        e.preventDefault();
        props.onChange(!props.checked);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: `toggle-switch  ${props.parentClassName}` +
                (props.small == true ? " big-switch" : "") },
            React.createElement("input", { type: "checkbox", name: props.name, className: "toggle-switch-checkbox", id: props.id, checked: props.checked, onChange: (e) => props.onChange(e.target.checked), disabled: props.disabled }),
            props.id ? (React.createElement("label", { className: `${props.switchcolorClass} ${props.checked == true
                    ? "toggle-switch-label e-switch-active"
                    : "toggle-switch-label"}`, tabIndex: props.disabled ? -1 : 1, onKeyDown: (e) => handleKeyPress(e), htmlFor: props.id },
                React.createElement("span", { className: "toggle-switch-inner", "data-yes": props.ToggleInnerDataYes, "data-no": props.ToggleInnerDataNo }),
                React.createElement("span", { className: `${props.switchcolorClass} ${(props.checked == true
                        ? "toggle-switch-switch e-switch-active"
                        : "toggle-switch-switch") +
                        (props.small == true ? " big-switch" : "")}` }))) : null)));
};
export default ToggleSwitch;
